export default "__VITE_ASSET__C8dmrR1i__"